
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateContainertypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    shortname: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    businessdivisionId: new FormControl<number | undefined>(undefined),
    config: new FormControl<any | undefined>(undefined, [Validators.required]),
})
;
}
      